import { ReactComponent as depositoLogo } from '../assets/icons/deposito.svg';
import { ReactComponent as navieraLogo } from '../assets/icons/naviera.svg';
import { ReactComponent as contenedorLogo } from '../assets/icons/contenedor.svg';
import { ReactComponent as turnoLogo } from '../assets/icons/cronograma2.svg';
import Icon from '@ant-design/icons';
import returnJwtValue from '../utils/helpers/token';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //
const permiso = returnJwtValue('Permiso');

// Normaliza a array
const permisosArray = permiso
  ? Array.isArray(permiso)
    ? permiso
    : [permiso]
  : [];

const entidades = permisosArray.map(path => path.split("/")[1]);

let menues = [];
if (entidades?.includes('Pedidos')) menues.push(
  {
    id: 'pedidos',
    title: 'Pedidos',
    type: 'item',
    url: '/interno/pedidos'
  }
)

if (entidades?.includes('Actividad')) menues.push(
  {
    id: 'actividad',
    title: 'Actividades',
    type: 'item',
    url: '/interno/actividades'
  }
)

if (entidades?.includes('Template')) menues.push(
  {
    id: 'template',
    title: 'Template actividades',
    type: 'item',
    url: '/interno/actividades/template'
  }
)

if (entidades?.includes('Materiales')) menues.push(
  {
    id: 'materiales',
    title: 'Materiales',
    type: 'item',
    url: '/interno/materiales'
  }
)

if (entidades?.includes('Remitos')) menues.push(
  {
    id: 'remitos',
    title: 'Remitos',
    type: 'item',
    url: '/interno/remitos'
  }
)

// if (entidades?.includes('Estadisticas')) menues.push(
//   {
//     id: 'estadisticas',
//     title: 'Estadisticas',
//     type: 'item',
//     url: '/interno/estadisticas'
//   }
// )

if (entidades?.includes('Usuarios')) menues.push(
  menues.push(
    {
      id: 'usuarios',
      title: 'Usuarios',
      type: 'item',
      url: '/interno/usuarios',
    })
)






const other = {
  id: 'other',
  title: 'Menu',
  type: 'group',
  children: menues
};

export default other;
